export default "__VITE_ASSET__f95c030b__"